import React, { useState } from "react";
import Swal from "sweetalert2";
import "./accountsettings.css";

const AccountSettings = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      Swal.fire({
        icon: "warning",
        title: "Missing Email",
        text: "Please enter your email",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("username", email);

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/api-reset`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      // ✅ Check your API’s success condition
      if (data.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: data.data || "Check your email!",
          confirmButtonColor: "#3085d6",
        });
        setEmail("");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "Something went wrong!",
          confirmButtonColor: "#d33",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Connection Failed",
        text: "Failed to connect to the server!",
        confirmButtonColor: "#d33",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account-settings">
      <h3 className="section-title">Change Password</h3>

      <form onSubmit={handleSubmit}>
        <div className="section">
          <div className="form-group">
            <label>Email Id</label>
            <div className="input-wrapper">
              <input
                type="email"
                value={email}
                placeholder="Enter your email"
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
            </div>
          </div>
        </div>

        <div className="section">
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AccountSettings;
